import type { Invoice } from "../../lib/gboModels";
import { canAttemptOnlinePayment } from "./payment";
import type { PaymentSummary } from "./payment";
import type { RootState } from "../../store/store";

export const selectCheckout = (state: RootState) => state.checkout;

export const selectCheckoutStep = (state: RootState) => selectCheckout(state).step;

export const selectSelectedAmount = (state: RootState) => selectCheckout(state).selectedAmount;

export const selectCustomAmount = (state: RootState) => selectCheckout(state).customAmount;

export const selectShowCustomAmountError = (state: RootState) => {
  const checkout = selectCheckout(state);
  return checkout.customAmountTouched || checkout.amountSubmitAttempted;
};

export function selectCanAttemptCheckout(
  payment: PaymentSummary,
  payOnlineEnabled: boolean,
  accountBalance: number,
  invoice?: Invoice,
) {
  return (
    payOnlineEnabled &&
    canAttemptOnlinePayment(payment) &&
    accountBalance > 0 &&
    (invoice == null || (!invoice.closed && !invoice.voided))
  );
}

export function selectNoPaymentDue(balance: number, closed?: boolean) {
  return balance <= 0 || Boolean(closed);
}
